"use client"
import { useEffect, useMemo, useState } from "react"
import * as Sentry from "@sentry/nextjs"
import { buildCorrelationId, ERROR_BOUNDARY_EVENTS, ERROR_BOUNDARY_PROPERTIES, trackBoundaryEvent } from "@/lib/ui/error-boundary"
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const [copied, setCopied] = useState(false)
  const correlationId = useMemo(() => buildCorrelationId(error), [error])
  const mailtoHref = `mailto:support@complyrx.io?subject=${encodeURIComponent(`Error ${correlationId}`)}`
  useEffect(() => {
    // Tagged with the support correlation id so a "code ABC123" email can be
    // matched to its Sentry event.
    Sentry.captureException(error, { tags: { correlation_id: correlationId, boundary: "global_error" } })
  }, [error, correlationId])
  useEffect(() => {
    trackBoundaryEvent(ERROR_BOUNDARY_EVENTS.BOUNDARY_RENDERED, { [ERROR_BOUNDARY_PROPERTIES.CORRELATION_ID]: correlationId, [ERROR_BOUNDARY_PROPERTIES.BOUNDARY_SCOPE]: "global_error", [ERROR_BOUNDARY_PROPERTIES.IS_NOT_FOUND_VARIANT]: false })
  }, [correlationId])
  async function copyCode() {
    try { await navigator.clipboard.writeText(correlationId); setCopied(true); trackBoundaryEvent(ERROR_BOUNDARY_EVENTS.CORRELATION_COPIED, { [ERROR_BOUNDARY_PROPERTIES.CORRELATION_ID]: correlationId, [ERROR_BOUNDARY_PROPERTIES.BOUNDARY_SCOPE]: "global_error" }); window.setTimeout(() => setCopied(false), 2000) } catch { setCopied(false) }
  }
  return <html><body style={{ margin: 0, padding: "48px", color: "#121212", fontFamily: "sans-serif" }}>
    <h1 style={{ fontSize: "24px", margin: 0 }}>ComplyRx failed to render.</h1>
    <p style={{ marginTop: "12px" }}>Try again now. If this keeps happening, email <a href={mailtoHref} style={{ color: "#121212" }}>support@complyrx.io</a> with code {correlationId}.</p>
    <p style={{ marginTop: "12px", fontFamily: "monospace", fontSize: "12px" }}>{correlationId} <button type="button" onClick={copyCode}>{copied ? "Copied" : "Copy code"}</button></p>
    <p style={{ marginTop: "16px" }}><button type="button" onClick={reset}>Try again</button> <a href="/tools/trial-tracker">Back to the tracker</a></p>
  </body></html>
}
